import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { updateUITabViewInfo } from '../../../app/appActions';
import { RequestList } from '../../presentationalComponents/RequestHistory/RequestList';
import { dispatchGetRequest } from '../../reduxUpdater/dispatchers/contactUsDispatchers';
import { isSearchingRequestsSelector, allRequestsSelector } from '../../reduxUpdater/selectors/requestHistorySelectors';
import { getRequestListStyles } from '../../styles/requestHistoryStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isSearchingRequests: isSearchingRequestsSelector(state),
    allRequests: allRequestsSelector(state)
  };
};

const mapDispatchToProps = {
  updateUITabViewInfo,
  dispatchGetRequest,
};

export const RequestListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestList, getRequestListStyles));

